import {apiMethods} from "../controller/Request";
import {Config} from "../controller/Global";

export const WorkOrderGet = (id, params = {}) => {
    const URL = Config['api']['tracks']['work_order']['get'] + id + '/';
    return apiMethods.get(URL, params, true)
        .then(response => {
            return response
        })

};
export const WorkOrderList = (params = {}) => {
    const URL = Config['api']['tracks']['work_order']['list'];
    return apiMethods.get(URL, params, true)
        .then(response => {
            return response
        })

};
export const WorkOrderPost = (params = {}) => {
    const URL = Config['api']['tracks']['work_order']['post'];
    return apiMethods.post(URL, JSON.stringify(params), true)
        .then(response => {
            return response
        })

};
export const WorkOrderUpdate = (id, params = {}) => {
    const URL = Config['api']['tracks']['work_order']['patch'] + id + '/';
    return apiMethods.patch(URL, JSON.stringify(params), true)
        .then(response => {
            return response
        })
};

export const WorkOrderRemove = (id, params = {}) => {
    const URL = Config['api']['tracks']['work_order']['delete'] + id + "/";
    return apiMethods.remove(URL, params, true)
        .then(response => {
            return response
        })

};
export const WorkOrderPDFList = (params = {}) => {
    const URL = Config['api']['pdf']['work_order']['list'];
    return apiMethods.getPDF(URL, params, true)
        .then(response => {
            return response
        })
};
export const DuplicateWorkOrder = (pk) => {
    const URL = Config['api']['tracks']['duplicate_work_order'] + pk + "/";
    return apiMethods.post(URL, JSON.stringify({pk}), true)
        .then(response => {
            return response
        })
};

export const WorkOrderDownloadCSV = (params = {}) => {
    const URL = Config['api']['tracks']['work_order']['csv'];
    return apiMethods.getRaw(URL, params, true)
        .then(response => {
            return response
        })
};



// WEBPACK FOOTER //
// ./src/models/workorder.jsx